var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "debounce", "prop-types", "react", "../../css", "../../UI/Interchange/Interchange", "./TeaserMain.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("debounce"), require("prop-types"), require("react"), require("../../css"), require("../../UI/Interchange/Interchange"), require("./TeaserMain.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.debounce, global.propTypes, global.react, global.css, global.Interchange, global.TeaserMain);
    global.TeaserMain = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _debounce, _propTypes, _react, _css, _Interchange, _TeaserMain) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _debounce = _interopRequireDefault(_debounce);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _Interchange = _interopRequireDefault(_Interchange);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var TeaserMain = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(TeaserMain, _PureComponent);

    var _super = _createSuper(TeaserMain);

    function TeaserMain(props) {
      var _this;

      (0, _classCallCheck2.default)(this, TeaserMain);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initTeaser", function (ref) {
        _this.teaser = ref;
      });
      _this.teaser = null;
      return _this;
    }

    (0, _createClass2.default)(TeaserMain, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.onMouseLeaveDebounce = (0, _debounce.default)(this.props.unpause, 300);
        this.onMouseOverDebounce = (0, _debounce.default)(this.props.pause, 300);
        this.teaser.addEventListener('mouseleave', this.onMouseLeaveDebounce);
        this.teaser.addEventListener('mouseover', this.onMouseOverDebounce);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.teaser.removeEventListener('mouseleave', this.onMouseLeaveDebounce);
        this.teaser.removeEventListener('mouseover', this.onMouseOverDebounce);
        this.onMouseLeaveDebounce.clear();
        this.onMouseOverDebounce.clear();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            beginsAt = _this$props.beginsAt,
            description = _this$props.description,
            images = _this$props.images,
            mouseFocus = _this$props.mouseFocus,
            pause = _this$props.pause,
            tabIndex = _this$props.tabIndex,
            title = _this$props.title,
            titlesElement = _this$props.titlesElement,
            unpause = _this$props.unpause,
            url = _this$props.url,
            urlRel = _this$props.urlRel,
            urlTarget = _this$props.urlTarget;
        return /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledWrapper, {
          ref: this.initTeaser
        }, /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledLink, {
          className: "teaser-focus",
          href: url,
          onBlur: unpause,
          onFocus: pause,
          onMouseLeave: this.onMouseLeaveDebounce,
          onMouseOver: this.onMouseOverDebounce,
          rel: urlRel,
          tabIndex: tabIndex,
          target: urlTarget
        }, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
          breakpointFormat: {
            xsmall: 'landscape',
            small: 'landscape',
            medium: 'landscape',
            large: 'landscape',
            xlarge: 'landscape',
            xxlarge: 'landscape'
          },
          images: images,
          hover: _css.hovers.main,
          mouseFocus: mouseFocus,
          title: title
        }), beginsAt && /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledDate, null, beginsAt), /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledCaption, null, titlesElement), description && /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledDescription, null, description)));
      }
    }]);
    return TeaserMain;
  }(_react.PureComponent);

  TeaserMain.propTypes = {
    beginsAt: _propTypes.default.string,
    description: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    mouseFocus: _propTypes.default.bool,
    pause: _propTypes.default.func.isRequired,
    tabIndex: _propTypes.default.number.isRequired,
    title: _propTypes.default.string.isRequired,
    titlesElement: _propTypes.default.node,
    unpause: _propTypes.default.func.isRequired,
    url: _propTypes.default.string.isRequired,
    urlRel: _propTypes.default.string,
    urlTarget: _propTypes.default.string
  };
  TeaserMain.defaultProps = {
    mouseFocus: false,
    pause: function pause() {},
    tabIndex: 0,
    title: '',
    unpause: function unpause() {},
    url: ''
  };
  var _default = TeaserMain;
  _exports.default = _default;
});